import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FileWithStatus } from '@interfaces';

function bytesToMB(bytes: number, decimals = 2) {
  const mb = bytes / (1024 * 1024);
  return parseFloat(mb.toFixed(decimals));
}

export function fileSizeValidator(maxSize?: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files: FileWithStatus[] = control.value;
    if (!files || files.length === 0) {
      return null;
    }

    if (maxSize) {
      const tooLarge = files.find(f => f.file.size > maxSize!);
      if (tooLarge) {
        return {
          maxSize: {
            actual: bytesToMB(tooLarge.file.size),
            max: bytesToMB(maxSize),
          },
        };
      }
    }

    return null;
  };
}
